<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
========================================================================================== -->


<template>
    <div class="">

        <!--========= header area ========-->
        <div class="header-area header-area--absolute">
            <div class="header-bottom-wrap header-sticky">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="header relative">
                                <div class="header__logo">
                                    <router-link :to="`${baseUrl}/home`">
                                        <img key="Logo" src="@/assets/images/logo/logo.png" alt="Axis Realty Group Logo" class="" />
                                    </router-link>
                                </div>

                                <div class="header-right">
                                    <div class="header__navigation menu-style-four d-none d-xl-block">                                    
                                    
                                        <div class="header-top-bar-info border-bottom d-none d-lg-block">
                                            <div class="top-bar-wrap">
                                                <div class="top-bar-left">
                                                    <div class="top-bar-text text-white">
                                                        <router-link :to="`${baseUrl}/apply-for-rental`" class="font-medium display-inline text-white">Apply For Rental</router-link>
                                                        <router-link :to="`${baseUrl}/pages/login`" target="_blank" class="font-medium display-inline text-white">Owner Login</router-link>
                                                        <router-link :to="`${baseUrl}/pages/login`" target="_blank" class="font-medium display-inline text-white">Resident Login</router-link>
                                                    </div>
                                                </div>
                                                <div class="top-bar-right">
                                                    <ul class="top-bar-info">
                                                        <li class="info-item">
                                                            <a href="tel:3144745277" class="info-link text-white">
                                                                <feather-icon icon="PhoneIcon" svgClasses="h-6 w-6" class="mr-2 align-middle" />
                                                                <span class="info-text">Call Us At <strong>(314) 474-5277</strong></span>
                                                            </a>
                                                        </li>
                                                        <li class="info-item" v-if="isLoggedIn" @click="logout"><router-link to="" class="text-white"><feather-icon icon="LogOutIcon" svgClasses="w-6 h-6" class="align-middle" /><span class="ml-2">Logout</span></router-link></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <nav class="navigation-menu">
                                            <ul>
                                                <li class=""><router-link :to="`${baseUrl}/home`"><span>Home</span></router-link></li>
                                                <li class=""><router-link :to="`${baseUrl}/property-management`"><span>Property Management</span></router-link></li>
                                                <li class="has-children has-children--multilevel-submenu">
                                                    <router-link :to="`${baseUrl}/tenant-resources`"><span>Residents</span></router-link>
                                                    <ul class="submenu">
                                                        <li><router-link :to="`${baseUrl}/tenant-resources`"><span>Tenant Resources</span></router-link></li>
                                                        <li><router-link :to="`${baseUrl}/pages/login`" target="_blank"><span>Maintenance Request</span></router-link></li>
                                                        <li><router-link :to="`${baseUrl}/pages/login`" target="_blank"><span>Tenant Login</span></router-link></li>
                                                        <li><router-link :to="`${baseUrl}/pages/login`" target="_blank"><span>Pay Rent</span></router-link></li>
                                                    </ul>
                                                </li>
                                                <li class="has-children has-children--multilevel-submenu">
                                                    <router-link :to="`${baseUrl}/about-us`"><span>About Us</span></router-link>
                                                    <ul class="submenu">
                                                        <li><router-link :to="`${baseUrl}/about-us`"><span>Our Company</span></router-link></li>
                                                        <li><router-link :to="`${baseUrl}/testimonials`"><span>Testimonials</span></router-link></li>
                                                    </ul>
                                                </li>
                                                <li class=""><router-link :to="`${baseUrl}/contact-us`"><span>Contact Us</span></router-link></li>
                                                <li class="" v-if="isLoggedIn"><router-link :to="`${baseUrl}/prospects`"><span>Prospects</span></router-link></li>
                                                <li class="" v-if="isLoggedIn"><router-link :to="`${baseUrl}/vacant-properties`"><span>Vacant Properties</span></router-link></li>
                                            </ul>
                                        </nav>
                                    </div>

                                    <!-- mobile menu -->
                                    <div @click="showMenu()" class="mobile-navigation-icon white-md-icon d-block d-xl-none" id="mobile-menu-trigger">
                                        <i></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div :class="showWindow ? 'mobile-menu-overlay active' : 'mobile-menu-overlay'" id="mobile-menu-overlay">
            <div class="mobile-menu-overlay__inner">
                <div class="mobile-menu-overlay__header">
                    <div class="container-fluid">
                        <div class="row align-items-center">
                            <div class="col-md-6 col-8">
                                <!-- logo -->
                                <div class="logo">
                                    <router-link :to="`${baseUrl}/home`">
                                        <img src="@/assets/images/logo/logo.png" class="img-fluid" alt="">
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-md-6 col-4">
                                <!-- mobile menu content -->
                                <div @click="closeWindow()" class="mobile-menu-content text-right">
                                    <span class="mobile-navigation-close-icon" id="mobile-menu-close-trigger"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mobile-menu-overlay__body">
                    <nav class="offcanvas-navigation">
                        <ul>
                            <li class=""><router-link :to="`${baseUrl}/home`"><span>Home</span></router-link></li>
                            <li class=""><router-link :to="`${baseUrl}/property-management`"><span>Property Management</span></router-link></li>
                            <li class="has-children" @click="selected = 1" :class="{active:selected == 1}">
                                <span class="menu-expand"><i></i></span>
                                <a href="#"><span>Residents</span></a>
                                <ul class="sub-menu">
                                    <li><router-link :to="`${baseUrl}/tenant-resources`"><span>Tenant Resources</span></router-link></li>
                                    <li><router-link :to="`${baseUrl}/pages/login`" target="_blank"><span>Maintenance Request</span></router-link></li>
                                    <li><router-link :to="`${baseUrl}/pages/login`" target="_blank"><span>Tenant Login</span></router-link></li>
                                    <li><router-link :to="`${baseUrl}/pages/login`" target="_blank"><span>Pay Rent</span></router-link></li>
                                </ul>
                            </li>
                            <li class="has-children" @click="selected = 2" :class="{active:selected == 2}">
                                <span class="menu-expand"><i></i></span>
                                <a href="#"><span>About Us</span></a>
                                <ul class="sub-menu">
                                    <li><router-link :to="`${baseUrl}/about-us`"><span>Our Company</span></router-link></li>
                                    <li><router-link :to="`${baseUrl}/testimonials`"><span>Testimonials</span></router-link></li>
                                </ul>
                            </li>
                            <li class=""><router-link :to="`${baseUrl}/contact-us`"><span>Contact Us</span></router-link></li>
                            <li class="" v-if="isLoggedIn"><router-link :to="`${baseUrl}/prospects`"><span>Prospects</span></router-link></li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <!--======== End of header area  ========-->

    </div>
</template>


<script>
import auth from '@/auth/authService.js'

//import Logo from '../Logo.vue'

export default {
  name: 'v-nav-menu',
  components: {
    //Logo
  },
  props: {
  },
  data () {
    return {
      selected: undefined,
      showWindow: false,
      isLoggedIn: auth.isAuthenticated()
    }
  },
  computed: {
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, ('/'))
    }
  },
  watch: {
  },
  methods: {
    closeWindow () {
      this.showWindow = false
    },
    showMenu () {
      this.showWindow = true
    },
    logout () {
      localStorage.removeItem('access_token')
      localStorage.removeItem('userInfo')
      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/home').catch(() => {})
    }
  },
  mounted () {
  }
}

</script>